export default {
  getReport: (state) => state.report,
};
